<div *ngIf="showMessage && !pictures?.length">
  <h1>No pictures to show</h1>
</div>

<div *ngIf="pictures?.length" class="main-div">
  <div id="left-column" style="flex: 1">
    <app-picture-viewer
      #pictureViewer
      [picture]="currentPicture"
      [flags]="getFlags()"
      [placeholderFlag]="placeholderFlag"
      (moveFlag)="moveFlag($event)"
      (addFlag)="addFlag($event)"
      (editFlag)="editFlag($event)"
      (markupChanged)="markupChanged($event)"
      (blobLoaded)="loadExif($event)"
      [disableFullscreen]="true">
    </app-picture-viewer>

    <div class="flag-panel">
      <a class="notification-flags" (click)="toggleFlags()" [class.disabled-link]="unpinnedFlagsCount() === 0">
        <i
          class="fa fa-flag fa-1x icon-styling"
          [ngStyle]="{ color: unpinnedFlagsCount() === 0 ? '#bbbbbb' : '#464646FF' }"></i>
        <span *ngIf="unpinnedFlagsCount() > 0" class="badge">{{ unpinnedFlagsCount() }}</span>
      </a>
      <a class="icon-container"><i (click)="showInfo()" class="fa fa-info icon-styling"></i><br /></a>
    </div>

    <div *ngIf="pictures.length > 1">
      <i *ngIf="hasPrev" (click)="prev()" class="fa fa-chevron-left has-prev"></i>
      <i *ngIf="hasNext" (click)="next()" class="fa fa-chevron-right has-next"></i>
    </div>

    <div class="date-bottom nelson">
      {{ formattedDateTime(currentPicture?.answer?.createdAt) }}
    </div>
  </div>

  <div id="right-column" *ngIf="showUnpinnedFlags" style="overflow: auto; position: relative">
    <app-unpinned-flags [picture]="currentPicture" (flagPinned)="pinFlag($event)"> </app-unpinned-flags>
  </div>
</div>

<div bsModal #info="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-child-name" class="modal-title pull-left">Picture Info</h4>
        <button type="button" class="closea pull-right" aria-label="Close" (click)="closeInfo()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table">
          <tr *ngFor="let r of exif">
            <td>{{ r.key }}</td>
            <td>{{ r.value | json }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>

<app-add-flag #addFlagModal></app-add-flag>
<app-edit-flag #editFlagModal></app-edit-flag>
